<template>
    <vx-form-prompt
        :title="title"
        v-model="patientForm"
        :active.sync="isActive"
        :steps="steps"
        :accept-text="acceptText"
        @completed="save"
    />
</template>

<script>
import PatientDetailsSectionVue from './PatientDetailsSection.vue'
import PatientContactInfoSection from './PatientContactInfoSection.vue'
import PatientMedicalInfoSection from './PatientMedicalInfoSection.vue'

export default {
    name: 'patient-creator',
    components: {
        PatientDetailsSectionVue,
        PatientContactInfoSection,
        PatientMedicalInfoSection
    },
    props: {
        active: {
            type: Boolean
        },
        value: {
            type: Object,
            required: false
        }
    },
    data() {
        return {
            patientForm: {
                patient: {
                    id: null,
                    firstName: null,
                    lastName: null,
                    dateOfBirth: null,
                    genderId: null,
                    indigenousId: 1,
                    isDeceased: false,
                    hasPensionCard: false,
                    medicareNumber: null,
                    dateOfDeath: null,
                    pensionCardNumber: null
                },
                contact: {
                    homePhone: null,
                    workPhone: null,
                    mobilePhone: null,
                    emailAddress: null,
                    address: {
                        streetAddress1: null,
                        streetAddress2: null,
                        suburb: null,
                        state: null,
                        postcode: null,
                        country: null
                    }
                },
                medical: {
                    diseases: [],
                    approvalGrantedDate: null,
                    additionalNotes: null
                }
            }
        }
    },
    computed: {
        isActive: {
            get() {
                return this.active
            },
            set(newValue) {
                return this.$emit('update:active', newValue)
            }
        },
        name() {
            if (this.patientForm.patient.firstName && this.patientForm.patient.lastName) {
                return `${this.patientForm.patient.firstName} ${this.patientForm.patient.lastName}`
            }
            return ''
        },
        steps() {
            var steps = [
                {
                    title: 'Patient Details',
                    name: 'Patient Details',
                    icon: 'feather icon-user',
                    component: PatientDetailsSectionVue,
                    next: null
                },
                {
                    title: 'Contact Info',
                    name: 'Contact Info',
                    icon: 'feather icon-map',
                    component: PatientContactInfoSection,
                    next: null
                },
                {
                    title: 'Medical Info',
                    name: 'Medical Info',
                    icon: 'feather icon-plus-square',
                    component: PatientMedicalInfoSection,
                    next: null
                }
            ]
            return steps
        },
        title() {
            if (this.value && this.value.id) {
                return `Editing Patient: ${this.value.firstName} ${this.value.lastName}`
            }
            return 'New Patient'
        },
        acceptText() {
            if (this.value && this.value.id) {
                return 'Save'
            }
            return 'Create'
        }
    },
    methods: {
        async save(finalPatientForm) {
            this.loading = true
            let patient = finalPatientForm.patient
            let medicalInfo = finalPatientForm.medical
            let contact = finalPatientForm.contact

            if (patient.dateOfBirth) {
                let dobDate = new Date(patient.dateOfBirth)
                patient.dateOfBirth = dobDate.toISODateString()
            }
            if (patient.dateOfDeath) {
                let dodDate = new Date(patient.dateOfDeath)
                patient.dateOfDeath = dodDate.toISODateString()
            }
            if (medicalInfo.approvalGrantedDate) {
                let agdDate = new Date(medicalInfo.approvalGrantedDate)
                medicalInfo.approvalGrantedDate = agdDate.toISODateString()
            }

            var patientPayload = {
                id: patient.id,
                firstName: patient.firstName,
                lastName: patient.lastName,
                genderId: patient.genderId,
                dateOfBirth: patient.dateOfBirth,
                indigenousId: patient.indigenousId,
                isDeceased: patient.isDeceased,
                hasPensionCard: patient.hasPensionCard,
                medicareNumber: patient.medicareNumber,
                dateOfDeath: patient.dateOfDeath,
                pensionCardNumber: patient.pensionCardNumber,

                homePhone: contact.homePhone,
                workPhone: contact.workPhone,
                mobilePhone: contact.mobilePhone,
                emailAddress: contact.emailAddress,
                address: contact.address,

                diseases: medicalInfo.diseases,
                approvalGrantedDate: medicalInfo.approvalGrantedDate,
                additionalNotes: medicalInfo.additionalNotes,
                otherDetails: medicalInfo.otherDetails
            }
            if (patientPayload.id) {
                this.edit(patientPayload)
            } else {
                this.add(patientPayload)
            }
        },
        async add(patientPayload) {
            this.loading = true
            try {
                var response = await this.$api.patient.create(patientPayload)
                this.notifySuccess(
                    'Created successfully',
                    `${this.name} has been created successfully`,
                    3000
                )
                this.$emit('patient-created', response)
                this.isActive = false
                this.$router.push({
                    name: 'patient-details',
                    params: {
                        patientId: response.id
                    }
                })
            } catch (error) {
                this.notifyServerError(error)
            } finally {
                this.loading = false
            }
        },

        async edit(patientPayload) {
            this.loading = true
            try {
                var response = await this.$api.patient.update(patientPayload)
                this.notifySuccess(
                    'Updated successfully',
                    `${this.name} has been updated successfully`,
                    3000
                )
                this.$emit('updated', response)
                this.$emit('input', response)
                this.$emit('close')
                this.isActive = false
            } catch (error) {
                this.notifyServerError(error)
            } finally {
                this.loading = false
            }
        }
    },
    mounted() {
        if (this.value) {
            var localValue = this.deepCopy(this.value)

            this.patientForm.patient = localValue

            this.patientForm.contact = localValue

            this.patientForm.medical = localValue
        }
    }
}
</script>

<style lang="scss" scoped></style>
